import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        threshold: { type: Number, default: 400 }
    }

    connect() {
        this.lastScrollTop = 0
        this.isHidden = false
        this.hidePosition = 0

        this.handleScroll = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.handleScroll)
    }

    disconnect() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop

        if (scrollTop > this.lastScrollTop) {
            if (scrollTop > this.thresholdValue && !this.isHidden) {
                this.element.style.transform = 'translateX(-50%) translateY(150px)'
                this.isHidden = true
                this.hidePosition = scrollTop
            }
        } else {
            if (this.isHidden && scrollTop <= this.hidePosition) {
                this.element.style.transform = 'translateX(-50%) translateY(0)'
                this.isHidden = false
            }
        }

        this.lastScrollTop = scrollTop
    }
}